import * as React from 'react'

import { Tag, TagColor } from '@factorialco/deprecated-design-system'
import { StatusVariant } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  status?: string
}
export const statusLabel = (status: string) => {
  const statusLabels: Record<string, string> = {
    pending_to_create: i18n.t('ats.application_details.disc_test.status.pending'),
    pending_to_complete: i18n.t('ats.application_details.disc_test.status.pending'),
    failed_to_process: i18n.t('ats.application_details.disc_test.status.failed_to_process'),
    completed: i18n.t('ats.application_details.disc_test.status.completed'),
  }

  return statusLabels[status] ?? ''
}

export const statusColor = (status: string) => {
  const statusColors: Record<string, StatusVariant> = {
    pending_to_create: 'info',
    pending_to_complete: 'info',
    failed_to_process: 'critical',
    completed: 'positive',
  }

  return statusColors[status] ?? 'info'
}

export const AssessmentStatusTag = ({ status = 'pending_to_create' }: Props) => {
  const statusToTagColor: Record<string, TagColor> = {
    ['pending_to_create']: TagColor.champagne,
    ['pending_to_complete']: TagColor.champagne,
    ['failed_to_process']: TagColor.radical,
    ['completed']: TagColor.viridian,
  }

  return (
    <Tag leftItem="circle" showCircle type={statusToTagColor[status]}>
      {statusLabel(status)}
    </Tag>
  )
}
